export default __webpack_public_path__ + "static/Design-conceitoVisual-d25200fcce391ccb1c87e46bfee4355f.png";